import { Component } from "@angular/core";

@Component({
  selector: "ngx-check-circle",
  template: ` <div class="fa fa-check-circle check"></div> `,
})
export class CheckCircleComponent {}
